import { render, staticRenderFns } from "./CustomSearchCP.vue?vue&type=template&id=3c4cb274&scoped=true"
import script from "./CustomSearchCP.vue?vue&type=script&lang=js"
export * from "./CustomSearchCP.vue?vue&type=script&lang=js"
import style0 from "./CustomSearchCP.vue?vue&type=style&index=0&id=3c4cb274&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4cb274",
  null
  
)

export default component.exports